<template>
  <TooltipView
    type="is-dark"
    position="is-bottom"
    :triggers="['hover']"
    :append-to-body="appendTooltipToBody"
    @open="onShowTooltip"
    @close="onCloseTooltip"
    ref="tooltipView"
    :class="isTriggerVisible ? 'is-visibility-visible' : 'is-visibility-hidden'"
  >
    <template #content>
      <div
        class="description p-1 is-flex is-align-items-center"
        :class="{ 'is-justify-content-center': !description && isAiUsed }"
      >
        <p
          v-if="description"
          class="description-text whitespace-pre-line m-b-0"
          :class="{ 'm-r-5': isAiUsed }"
        >
          {{ description }}
        </p>
        <span
          v-if="isAiUsed"
          class="is-flex is-align-items-center is-flex-shrink-0"
          role="img"
          :title="$t('timeentry.i-used-ai-for-this-entry')"
          :aria-label="$t('timeentry.i-used-ai-for-this-entry')"
          :data-e2e="TimeEntryCypressAttribute.views.TIME_ENTRY_ROW_USED_AI"
        >
          <IconView pack="cls" icon="cls-magic-stars" class="is-size-6 has-text-primary" />
        </span>
      </div>
    </template>
    <IconView
      pack="cls"
      icon="cls-note-pin"
      class="is-size-6 is-clickable"
      :class="{ 'has-text-primary': isTooltipOpen }"
    />
  </TooltipView>
</template>

<script>
import IconView from '@/modules/core/ui/components/wrappers/IconView.vue';
import TooltipView from '@/modules/core/ui/components/wrappers/TooltipView.vue';
import { TimeEntryCypressAttribute } from '@/modules/timeentry/constants/TimeEntryCypressAttribute';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'TimeEntryDescriptionTooltip',
  components: { IconView, TooltipView },
  props: {
    description: {
      type: String
    },
    isAiUsed: {
      type: Boolean,
      default: false
    },
    appendTooltipToBody: {
      type: Boolean,
      default: true
    }
  },
  static: {
    TimeEntryCypressAttribute
  },
  data() {
    return {
      isTooltipOpen: false
    };
  },
  computed: {
    isTriggerVisible() {
      return !!(this.description || this.isAiUsed);
    }
  },
  methods: {
    onShowTooltip() {
      this.isTooltipOpen = true;
      this.$refs.tooltipView.setZIndex(109);
    },
    onCloseTooltip() {
      this.isTooltipOpen = false;
    }
  }
};
</script>

<style scoped>
.description {
  min-width: var(--ce-150px);
}

.description.is-flex > .description-text {
  min-width: 0;
}
</style>
